import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";
import { loadSellers, setUser } from "../../redux/actions/user";
import { useDispatch } from "react-redux";
import { setStoredCurrentProfile } from "../../utils/shopProfile";
import { cacheAuthUser, persistAuthToken } from "../../utils/authSession";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [identifier, setIdentifier] = useState(String(searchParams.get("identifier") || ""));
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);

  const requestedRedirect = String(searchParams.get("redirect") || "").trim();
  const redirectPath = requestedRedirect.startsWith("/") && !requestedRedirect.startsWith("//")
    ? requestedRedirect
    : "/home";

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const res = await axios.post(
        `${server}/user/login-user`,
        {
          identifier,
          password,
        },
        { withCredentials: true }
      );
      
      toast.success("Login Success!");
      const { user, token } = res.data;
      
      // Dispatch setUser
      dispatch(setUser(user));
      cacheAuthUser(user);
      if (token || user?.token) {
        persistAuthToken(token || user.token);
      }
      setStoredCurrentProfile("User");
      
      // Wait for loadSellers to complete before navigating
      await dispatch(loadSellers());
      
      navigate(redirectPath, { replace: true });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Login failed. Please try again.";
      toast.error(message);
    }
  };
  

  return (
    <div className="login-component-container">
      <div className="login-component-header">
        <h2 className="login-component-title">
          Login to your account
        </h2>
      </div>
      <div className="login-component-form-container">
        <div className="login-component-form-wrapper">
          <form className="login-component-form" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="identifier"
                className="login-component-label"
              >
                Email or Handle
              </label>
              <div className="login-component-input-wrapper">
                <input
                  type="text"
                  name="identifier"
                  autoComplete="username"
                  required
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  className="login-component-input"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="password"
                className="login-component-label"
              >
                Password
              </label>
              <div className="login-component-input-wrapper relative">
                <input
                  type={visible ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-component-input"
                />
                {visible ? (
                  <AiOutlineEye
                    className="login-component-icon"
                    size={25}
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    className="login-component-icon"
                    size={25}
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>
            </div>
            <div className="login-component-options">
              <div className="login-component-remember-me">
                <input
                  type="checkbox"
                  name="remember-me"
                  id="remember-me"
                  className="login-component-checkbox"
                />
                <label
                  htmlFor="remember-me"
                  className="login-component-checkbox-label"
                >
                  Remember me
                </label>
              </div>
              <div className="login-component-forgot-password">
                <Link
                  to="/forgot-password"
                  className="login-component-forgot-password-link"
                >
                  Forgot your password?
                </Link>
                <Link
                  to="/forgot-username"
                  className="login-component-forgot-password-link"
                >
                  Forgot your handle?
                </Link>
              </div>
            </div>
            <div>
              <button
                type="submit"
                className="login-component-submit-button"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;


